import React, { useEffect, useContext } from "react"
import MobileSidePanel from "@quarkly/community-kit/MobileSidePanel"
import { MobileSidePanelContext } from "@quarkly/community-kit/MobileSidePanel/utils"

const MenuCloser = () => {
  const context = useContext(MobileSidePanelContext)

  useEffect(() => {
    const handleClick = e => {
      const anchor = e.target.closest("a")
      if (anchor) {
        // If menu is open, close it first
        if (context && context.closePanel && context.isOpen) {
          context.closePanel()
        }

        // Handle smooth scrolling for anchor links manually
        const href = anchor.getAttribute("href")
        if (href && href.startsWith("#") && href.length > 1) {
          const targetElement = document.getElementById(href.substring(1))
          if (targetElement) {
            e.preventDefault()
            // Wait a tiny bit for the body scroll position to be restored by closePanel
            setTimeout(() => {
              targetElement.scrollIntoView({ behavior: "smooth" })
            }, 10)
          }
        }
      }
    }
    document.addEventListener("click", handleClick, true)
    return () => document.removeEventListener("click", handleClick, true)
  }, [context])

  return null
}

const CustomMobileSidePanel = props => {
  const children = React.Children.toArray(props.children)
  children.push(<MenuCloser key="menu-closer" />)
  return <MobileSidePanel {...props}>{children}</MobileSidePanel>
}

Object.assign(CustomMobileSidePanel, MobileSidePanel)

export default CustomMobileSidePanel
